<template>
  <modal
      @close="$emit('close')"
      class="custom-popup medium-size"
  >
    <template slot="header">
      <span
        v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
        <span class="admin-edit" @click="editTranslate(['zonePrice_importPrices',])"></span>
        {{$t('zonePrice_importPrices.localization_value.value')}}
      </span>
    </template>
    <template slot="body">
      <div class="import-transaction__content"
           v-bind:class="{'admin-edit-item': $store.getters.getUserProfile.isAdmin || checkImpersonate()}">
        <span class="admin-edit" @click="editTranslate(['zonePrice_fileImport',])"></span>
        <div class="custom-popup__txt size-18px">
          {{$t('zonePrice_fileImport.localization_value.value')}}
        </div>
        <div class="import-transaction__row custom-row">
          <div class="import-transaction__col custom-col position-relative">
            <DropZone class="drop-zone-bg"
                      :parentFiles="PC.data.File.data.files"
                      @changeImg="changeImg"
                      :accept="'application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/csv'"
                      :maxSize="'3'"
            />
            <div class="error-field ml-3" v-if="PC.data.File.validation.files">
              {{$t('common_fileIsRequired.localization_value.value')}}
            </div>
          </div>
        </div>
      </div>
    </template>
    <template slot="footer">
      <div class="import-transaction__btn d-flex align-items-center flex-wrap">
        <span
            class="site-link site-link--alt import-transaction__btn-i mt-3 mr-3 mb-3"
            @click="$emit('close')"
        >
          {{$t('common_cancel.localization_value.value')}}
        </span>

        <MainButton
            :value="$t('common_send.localization_value.value')"
            class="import-transaction__btn-i"
            @click.native="importProducts"
        />
      </div>
    </template>
  </modal>
</template>

<script>
  import Modal from '../../../../commonModals/Modal.vue'
  import MainButton from '../../../../UI/buttons/MainButton/MainButton.vue'
  import DropZone from "../../../../coreComponents/DropZone/DropZone";
  import {PromoCode} from "@/components/globalModels/PromoCode";

  export default {
    name: "PromoCodeImportPopup",
    components: {
      Modal,
      MainButton,
      DropZone,
    },

    data(){
      return {
        files: [],
        PC: new PromoCode(),

        optionsDeliveryServices: [],
        optionsCurrency: [],
        optionsCountry: [],
        optionsWarehouses: [],

      }
    },

    mounted() {

    },

    methods: {

      changeImg(files, maxSizeError) {
        this.PC.data.File.setFiles(files)

        this.PC.data.File.setFilesMaxSizeError(maxSizeError)
      },

      importProducts() {

        if(!this.PC.data.File.firstValidation()) return

        let data = null
        let files = this.PC.data.File.data.files

        files.map((item) => {
          let reader = new FormData()
          reader.append("import-file", item.file)
          data = reader
        })


        this.$store.dispatch('importPromoCode', data).then((response) => {

          switch (this.getResponseStatus(response)) {
              /**
               * Success
               */
            case this.$store.getters.GET_ERRORS.SUCCESS_CODE: {

              this.openNotify('success', 'common_notificationRecordChanged')
              this.$emit('reload')
              this.$emit('close')

              break
            }
              /**
               * Validation Error
               */
            case this.$store.getters.GET_ERRORS.VALIDATION_ERROR_CODE: {
              let errors = response.response.data.errors;
              this.notifyErrorHelper(errors)
              break
            }
              /**
               * Undefined Error
               */
            default: {
              this.openNotify('error', 'common_notificationUndefinedError')
            }
          }
        }).catch(error => this.createErrorLog(error))

      },
    }
  }

</script>

<style scoped>
  .size-18px{
    font-size: 18px;
  }

  @media(max-width: 1150px){
    .size-18px{
      font-size: 16px;
    }
  }
</style>
